const __WEBPACK_NAMESPACE_OBJECT__ = require("core-js/modules/es.array.sort.js");